/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { PaymentApiConfiguration } from '../payment-api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { PaymentGet200ResponseDtoDto } from '../models/payment-get-200-response-dto-dto';


/**
 * the PmaQueryReadPayment API
 */
@Injectable({
  providedIn: 'root',
})
export class PmaQueryReadPaymentService extends BaseService {
  constructor(
    config: PaymentApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation paymentGet
   */
  static readonly PaymentGetPath = '/payment';

  /**
   * Get payment.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `paymentGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  paymentGet$Response(params: {
    payment_uid: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<PaymentGet200ResponseDtoDto>> {

    const rb = new RequestBuilder(this.rootUrl, PmaQueryReadPaymentService.PaymentGetPath, 'get');
    if (params) {
      rb.query('payment_uid', params.payment_uid, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PaymentGet200ResponseDtoDto>;
      })
    );
  }

  /**
   * Get payment.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `paymentGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  paymentGet(params: {
    payment_uid: string;
  },
  context?: HttpContext

): Observable<PaymentGet200ResponseDtoDto> {

    return this.paymentGet$Response(params,context).pipe(
      map((r: StrictHttpResponse<PaymentGet200ResponseDtoDto>) => r.body as PaymentGet200ResponseDtoDto)
    );
  }

}
